import React from "react";

export default function MoonPhaseIcon({ fullness = 0, waxing = true, size = 11 }) {
  const clipId = React.useId();
  const clamped = Math.max(0, Math.min(1, fullness));
  const brightWidth = Math.max(0.08, clamped);
  const brightX = waxing ? 1 - brightWidth : 0;

  return (
    <span
      aria-hidden="true"
      style={{
        width: size,
        height: size,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        verticalAlign: "middle",
      }}
    >
      <svg width={size} height={size} viewBox="0 0 12 12" fill="none">
        <defs>
          <clipPath id={clipId}>
            <circle cx="6" cy="6" r="5" />
          </clipPath>
        </defs>
        <circle cx="6" cy="6" r="5" fill="#1a2838" stroke="#9db3c9" strokeWidth="0.8" />
        <rect x={brightX * 12} y="0" width={brightWidth * 12} height="12" fill="#f2ead2" clipPath={`url(#${clipId})`} />
      </svg>
    </span>
  );
}
